import type {ReactElement} from 'react';
import {ColorControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/color-control/color-control';
import {DEFAULT_TEXT_COLOR} from '@FormMakerReact/layout/form-maker-right-panel/sectors/sectors.constants';
import type {DescriptionTextColorControlProps} from './description-text-color-control.types';

export function DescriptionTextColorControl({component}: DescriptionTextColorControlProps): ReactElement {
  return (
    <ColorControl
      component={component}
      property="color"
      labelKey="pmwjs_form_maker_control_text_color_label"
      pickAriaKey="pmwjs_form_maker_control_text_color_pick"
      clearAriaKey="pmwjs_form_maker_control_text_color_clear"
      defaultColor={DEFAULT_TEXT_COLOR}
      hideClearButton
    />
  );
}